import { useRef } from 'react';
/**
 * A wrapper around useRef that can be used to maintain references to a dynamic set of elements or components.
 *
 * Example usage:
 *
 * // Create a ref map with the element type.
 * const itemRefs = useRefMap<HTMLLIElement>();
 *
 * // Map the list of elements, using the `set` method to set the ref for each element.
 * return (
 *   <ul>
 *     {props.list.map(element => (
 *       <li key={element.id} ref={itemRefs.set(element.id)}>
 *         {element.name}
 *       </li>
 *     ))}
 *   </ul>
 * );
 *
 * // Use the `get` method to access a particular ref.
 * const itemRef = itemRefs.get('id');
 */
export function useRefMap() {
    const map = useRef(new Map());
    return {
        get: (key) => map.current.get(key),
        set: (key) => (value) => {
            if (value == null) {
                map.current.delete(key);
            }
            else {
                map.current.set(key, value);
            }
        }
    };
}
//# sourceMappingURL=use-ref-map.js.map